import { render, staticRenderFns } from "./GoodsContent.vue?vue&type=template&id=6fa75794&scoped=true&"
import script from "./GoodsContent.vue?vue&type=script&lang=js&"
export * from "./GoodsContent.vue?vue&type=script&lang=js&"
import style0 from "./GoodsContent.vue?vue&type=style&index=0&id=6fa75794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa75794",
  null
  
)

export default component.exports